module.exports = __webpack_public_path__ + "media/P03.3a0c5971.mp4";